var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 16 20",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.104.932c0-.93-1.197-1.28-1.724-.51-4.838 7.072 2.037 7.39 2.037 10.828 0 1.392-1.138 2.518-2.534 2.5-1.373-.018-2.466-1.163-2.466-2.537v-3.34c0-.848-1.034-1.26-1.619-.645-1.045 1.098-2.131 2.98-2.131 5.272 0 4.136 3.364 7.5 7.5 7.5 4.135 0 7.5-3.364 7.5-7.5 0-6.652-6.563-7.54-6.563-11.568z",
    fill: "#2d2d2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFire);
export default __webpack_public_path__ + "static/media/icn_fire.a0b82f7d6731e2efe2f55203b4d9bb7d.svg";
export { ForwardRef as ReactComponent };